import(/* webpackMode: "eager" */ "/root/repo/src/app/affiliate/page.tsx");
